var exports = {
  "GF": "ReportFlowPreview.module__messageScroller___Y0NZV0",
  "BK": "ReportFlowPreview.module__messageContent___Y0NZV0",
  "Kg": "ReportFlowPreview.module__userCard___Y0NZV0",
  "fz": "ReportFlowPreview.module__userText___Y0NZV0",
  "nT": "ReportFlowPreview.module__userName___Y0NZV0",
  "a1": "ReportFlowPreview.module__userTag___Y0NZV0",
};

module.exports = exports;
